/**
 * URL encoding that keeps '@' literal. Game codes (SKC@LAG) and registry
 * slugs (pdm-card@1.0.8) are all over our URLs; '@' is a legal character in
 * BOTH a path segment and a query value (RFC 3986 sub-delim), and staff read
 * these URLs — %40 everywhere is pure noise (founder, 2026-08-25, restated
 * 2026-08-27: never %40, always @).
 *
 * Use this for every game code that goes into a URL. It is NOT for encoding a
 * whole URL or pathname as a query value (see
 * lib/api.ts) — those must stay fully escaped.
 */
export const pathSeg = (s: string): string =>
  encodeURIComponent(s).replace(/%40/g, '@')
